import { Loader, PageLayout } from '@bharatpe/bharat-ui';
import AppHeader from 'components/atoms/AppHeader';
import React, { useEffect, useState } from 'react';
import { SET_UPI_DATA, useOnBoardingRedirection, useSelectedSim, useUpiData } from 'Slices';
import BankItemList from '../../../components/molecules/BankItemList';
import history from 'utils/History';
import UpiPoweredBy from 'components/atoms/UpiPoweredBy';
import { IUserBank } from 'types';
import { fetchUpiProfile, UPIActivateAccount } from 'utils/nativeUpiHandler';
import { useDispatch } from 'react-redux';
import { sendEvent } from 'utils/Sentry';
import Toasty from 'components/atoms/Toasty';
import { checkSettlementAccountMatch, deviceBindingRedirectionHandle } from 'utils/deviceBindingHelper';
import AllModals from 'containers/UPIContainer/Modals';
import { ONBOARDING_REDIRECTION_PAGE, UPI_ERROR_CODE } from 'utils/CONSTANT';
import { triggerCustomerSettlementAccountApi } from 'Slices/GetCustomerSettlementAccount';
import { triggerSettlementAccountApi } from 'Slices/GetSettlementAccount';

const ReclaimBankList: React.FC = () => {
	const [loading, setLoading] = useState(false);
	const upiData = useUpiData();
	const sim = useSelectedSim();
	const { user_banks, reclaimStatus = false } = upiData?.upiProfileDetails || {};
	const dispatch = useDispatch();
	const onBoardingRedirection = useOnBoardingRedirection();

	useEffect(() => {
		switch (onBoardingRedirection.source) {
			case ONBOARDING_REDIRECTION_PAGE.PROFILE:
				dispatch(triggerCustomerSettlementAccountApi());

				break;
			case ONBOARDING_REDIRECTION_PAGE.MANDATE:
				dispatch(triggerSettlementAccountApi());
				break;
		}
	}, [dispatch]);

	const onHandleClick = (bankAccountId: string) => {
		history.push({ pathname: '/account/bank-account-details', search: `?bank-account-id=${bankAccountId}` });
	};

	const getUpiProfileDetails = async (profileId?: string) => {
		try {
			const data = await fetchUpiProfile(profileId || '');
			const { profileDetails } = data as any;
			if (profileDetails) {
				dispatch(SET_UPI_DATA({ ...upiData, upiProfileDetails: profileDetails, upiDataFetched: true }));
			}
		} catch (err: any) {
			if (UPI_ERROR_CODE.includes(err?.errorCode)) Toasty.error(err?.error);
			else Toasty.error('Something went wrong !!!');
			sendEvent(err);
		}
	};

	const activateAccount = async (bankData: IUserBank) => {
		setLoading(true);
		try {
			const data = await UPIActivateAccount(bankData);
			if (data) {
				await getUpiProfileDetails('');
			}
			if (onBoardingRedirection.source === ONBOARDING_REDIRECTION_PAGE.MANDATE) {
				const isMatchedSettlementAccount = await checkSettlementAccountMatch(onBoardingRedirection.source);
				if (!isMatchedSettlementAccount) {
					history.push({
						pathname: '/upi/bank-selection',
						state: { selectedSim: sim },
					});
					return;
				}
			}
			setLoading(false);
			deviceBindingRedirectionHandle();
			setLoading(false);
		} catch (err: any) {
			setLoading(false);
			if (UPI_ERROR_CODE.includes(err?.errorCode)) Toasty.error(err?.error);
			else Toasty.error('Something went wrong !!!');
		}
	};

	return loading ? (
		<Loader loading />
	) : (
		<PageLayout className="white-background ">
			<>
				<AppHeader title={'Linked Bank Accounts'} />
				<div className="mx5 mt6">
					{user_banks?.map((bank, idx) => (
						<BankItemList
							key={idx}
							bank={bank}
							reclaimStatus={reclaimStatus}
							activateAccount={activateAccount}
							onHandleClick={onHandleClick}
						/>
					))}
				</div>
				<AllModals />
				<div className="upi-powered">
					<UpiPoweredBy />
				</div>
			</>
		</PageLayout>
	);
};
export default ReclaimBankList;
